module.exports = __webpack_public_path__ + "static/headerBackground-faa0c2cc4cbb49a203d86e6fe3336318.png";